import { render, staticRenderFns } from "./RemoveUser.vue?vue&type=template&id=46a70136&"
import script from "./RemoveUser.vue?vue&type=script&lang=js&"
export * from "./RemoveUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports